import { useState } from "react";
import { FaRegCopy, FaUserFriends } from "react-icons/fa";
import Toast from "./Toast"; // ✅ Import Toast
import "../styles/referralCard.css"; // Ensure this CSS file exists

const ReferralCard = ({ referralCode }) => {
  // Construct referral link dynamically
  const referralLink = `${window.location.origin}/register?ref=${referralCode}`;

  const [copied, setCopied] = useState({ type: null });

  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("info");

  const showToast = (message, type = "info") => {
    setToastMessage(message);
    setToastType(type);
  };


  // Function to copy text
  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied({ type });
        showToast(`${type === "link" ? "Referral link" : "Code"} copied!`, "success");
      })
      .catch(() => {
        showToast("Failed to copy", "error");
      });

    setTimeout(() => setCopied({ type: null }), 2000);
  };

  return (
    <div className="referral-card">
       {toastMessage && (
        <Toast
          message={toastMessage}
          type={toastType}
          onClose={() => setToastMessage("")}
        />
      )}
      {/* Icon and Heading */}
      <div className="referral-icon">
        <FaUserFriends size={40} color=" #117378" />
      </div>
      <h3>Invite Your Friends & Earn Rewards</h3>
      <p>Get <strong>3% of their first deposit</strong> when they sign up using your referral.</p>
      <p>Earn up to <strong>₦1000</strong> when your referrals deposit a total of <strong>₦33,333.33</strong>.</p>

      {/* Referral Link */}
      <div className="referral-section">
        <label>Your Referral Link</label>
        <div className="referral-input">
          <input type="text" value={referralLink} readOnly />
          <button className="copy-btn" onClick={() => copyToClipboard(referralLink, "link")}>
            <FaRegCopy />
          </button>
          {copied.type === "link" && <span className="copied-popup">Copied!</span>}
        </div>
      </div>

      {/* Referral Code */}
      <div className="referral-section">
        <label>Your Referral Code</label>
        <div className="referral-input">
          <input type="text" value={referralCode} readOnly />
          <button className="copy-btn" onClick={() => copyToClipboard(referralCode, "code")}>
            <FaRegCopy />
          </button>
          {copied.type === "code" && <span className="copied-popup">Copied!</span>}
        </div>
      </div>
    </div>
  );
};

export default ReferralCard;
